<template>
    <div class="card directory-list-card">
        <div class="card-header directory-list-card__header">
            <div class="directory-list-card__title">
                <h4>{{ $t('User Directory') }}</h4>
            </div>
            <div class="directory-list-card__actions">
                <button class="btn btn-primary directory-add-btn"
                @click="OpenCreateModal"
                data-bs-toggle="modal" data-bs-target="#CreateUserModal"
                ><i class="fa-solid fa-plus"></i> {{ $t('Add User') }}</button>
            </div>
        </div>
        <div class="card-body directory-list-card__body">
            <div class="directory-list-toolbar">
                <div class="directory-search">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    <input type="text" :placeholder="$t('Search User here...')" class="form-control" :value="search" @input="searchUser($event.target.value)"/>
                </div>
                <div class="directory-pagination" v-if="userList.totalDocs">
                    <Pagination
                        :paginationDetails="{totalPages : userList.totalPages, page : userList.page}"
                        :changePage="ChangePage" 
                    ></Pagination>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="table-responsive">
                <table class="table table-striped directory-table">
                    <thead>
                        <tr>
                            <th>{{ $t('Name') }}</th>
                            <th>{{ $t('Role') }}</th>
                            <th>{{ $t('Office') }}</th>
                            <th>{{ $t('Created At') }}</th>
                            <th class="directory-status-col">{{ $t('Status') }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody class="text-capitalize">
                        <tr v-if="userList.totalDocs==0">
                            <td colspan="6" class="text-center directory-empty-state">{{ $t('No Data Found') }}</td>
                        </tr>
                        <tr v-for="(item, index) in userList.docs" :key="item._id || index" :class="{ 'is-highlighted': item._id === highlightedUserId }">
                            <td class="directory-user-name">{{item.fullname}}</td>
                            <td>{{item.roleId?.roleName}}</td>
                            <td>{{item.officeId?.officeName}} - {{item.regionId?.regionName}}</td>
                            <td>{{formatDate(item.createAt)}}</td>
                            <td class="directory-status-col">
                                <span class="badge bg-primary text-white" v-if="item.status">{{ $t('Active') }}</span>
                                <span class="badge bg-danger text-white" v-else>{{ $t('Inactive') }}</span>
                            </td>
                            <td class="directory-table__actions">
                                <button class="directory-icon-btn directory-icon-btn--edit" @click="OpenUpdateModal(item._id)" data-bs-toggle="modal" data-bs-target="#UpdateUserModal" :title="$t('Edit')"><i class="fa-solid fa-pen"></i></button>
                                <button class="directory-icon-btn directory-icon-btn--status" :title="item.status ? $t('Deactivate User') : $t('Activate User')" @click="BlockUser(item)" ><i class="fa-solid fa-lock"></i></button>
                            </td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Pagination from '@/components/layout/Pagination.vue'
import {ReformatDate} from '@/helpers/utilities.js'
import {confirmDirectoryStatusChange} from '@/helpers/directoryStatusConfirm.js'
export default {
    
    name : 'UserList',
    components : {
        Pagination
    },
    props : ['OpenUpdateModal','OpenCreateModal','highlightedUserId','clearHighlight'],
    data(){
        return {
            timer : null
        }
    },
    methods : {
        formatDate (value){
            return ReformatDate(value)
        },
        timerSetter(typed, callback, seachEmpty = false){
            const self = this
            if(!seachEmpty){
                if(!typed){
                return
                }
            }
            
            if(self.timer){
                clearTimeout(self.timer)
                self.timer = null
            }

            self.timer = setTimeout(callback,700)
        },
        searchUser(search){
            const self = this
            if(typeof self.clearHighlight === 'function'){
                self.clearHighlight()
            }
            self.timerSetter(search,function(){
                self.GetUserList({search : search, page : 1}).catch()
            },true)
        },
        ChangePage (page){
            if(typeof this.clearHighlight === 'function'){
                this.clearHighlight()
            }
            this.GetUserList({search : this.search, page : page}).catch()
        },
        ...mapActions(['GetUserList','GetUserDirectoryInitial','GetUserInfo','UpdateUserStatusRun']),
        BlockUser(user){
            return confirmDirectoryStatusChange(this, {
                entityName: 'User',
                itemName: user.fullname,
                isActive: Boolean(user.status),
                onConfirm: () => this.UpdateUserStatusRun(user._id),
                activeDescription: ({ highlightedName, currentStatus, nextStatus }) => `Are you sure you want to deactivate ${highlightedName}? Their status will change from ${currentStatus} to ${nextStatus}, and they will no longer be able to access the system.`,
                inactiveDescription: ({ highlightedName, currentStatus, nextStatus }) => `Are you sure you want to activate ${highlightedName}? Their status will change from ${currentStatus} to ${nextStatus}, and they will be able to access the system again.`,
                successDescriptionBuilder: ({ completedAction, highlightedName, nextStatus }) => `${highlightedName} has been ${completedAction.toLowerCase()} successfully. Their status is now ${nextStatus}.`,
                errorMessage: 'Unable to update user status.'
            })
        }
    },
    computed : mapGetters(['userList','search'])
}
</script>
